<template>
    <div>
        <card-header icon="fa-circle-dollar" title="Payment Plan Forecast" />

        <card-body>
            <card-list>
                <subheader-list-item :title="'Overall'" />
            </card-list>
            <card-list>
                <separator-list-item />
            </card-list>
            <data-row :title="'Owed'">
                <span style="font-weight: bold;">{{ totalOwed | currency }}</span>
            </data-row>
            <data-row :title="'Paid'">
                <span style="font-weight: bold;">{{ totalPaid | currency }}</span>
            </data-row>
            <data-row :title="'Remaining'">
                <span style="font-weight: bold;">{{ totalOwed - totalPaid | currency }}</span>
            </data-row>
            <data-row :title="'Active'">
                <span style="font-weight: bold;">{{ this.activePlans }} of {{ this.totalPlans }} total plans</span>
            </data-row>
            <template v-for="year in forecast">
                <card-list>
                    <subheader-list-item :title="year.year + ''" />
                </card-list>
                <data-row :title="'Year total'">
                    <div style="width: 50%; float: left; font-weight: bold;">
                        {{ year.totals.totalPaid | currency }}
                    </div>
                    <div style="width: 50%; float: right; font-weight: bold;">
                        {{ year.totals.totalPlans }} plans
                    </div>
                </data-row>
                <card-list v-if="year.months && year.months.length > 0">
                    <separator-list-item />
                </card-list>
                <!-- label the columns -->
                <data-row v-if="year.months && year.months.length > 0" :title="'Month'" :icon="'fa-calendar-alt'"
                    :mini="true">
                    <div style="width: 50%; float: left; font-weight: bold;">
                        Total Payments
                    </div>
                    <div style="width: 50%; float: right; font-weight: bold;">
                        Total Active Plans
                    </div>
                </data-row>
                <div v-for="month in year.months">
                    <data-row
                        v-if="moment().year() == year.year && moment(month.month).month() == moment().month()"
                        :title="shortMonthStrings[new Date(month.month).getMonth() + 1]" :icon="'fa-spinner'">
                        <div style="width: 50%; float: left; font-weight: bold;">
                            {{ month.totals.totalToBePaid | currency }}
                        </div>
                        <div style="width: 50%; float: right; font-weight: bold;">
                            {{ month.totals.totalPlans }}
                        </div>
                    </data-row>
                    <data-row
                        v-else-if="(moment().year() > year.year) || (moment().year() == year.year && moment(month.month).month() < moment().month())"
                        :title="shortMonthStrings[moment(month.month).month()]" :icon="'fa-circle-check'">
                        <div style="width: 50%; float: left; font-weight: bold;">
                            {{ month.totals.totalToBePaid | currency }}
                        </div>
                        <div style="width: 50%; float: right; font-weight: bold;">
                            {{ month.totals.totalPlans }}
                        </div>
                    </data-row>
                    <data-row v-else :title="shortMonthStrings[moment(month.month).month()]">
                        <div style="width: 50%; float: left; font-weight: bold;">
                            {{ month.totals.totalToBePaid | currency }}
                        </div>
                        <div style="width: 50%; float: right; font-weight: bold;">
                            {{ month.totals.totalPlans }}
                        </div>
                    </data-row>
                </div>
            </template>
        </card-body>

        <card-footer>

        </card-footer>
    </div>
</template>

<script>
import CardHeader from "@/TIER/components/CardHeader";
import CardBody from "@/TIER/components/CardBody";
import CardFooter from "../../TIER/components/CardFooter";
import CardList from "../../TIER/components/CardList";
import SubheaderListItem from "../../TIER/components/SubheaderListItem";
import DataRow from "../../TIER/components/DataRow";
import SeparatorListItem from "../../TIER/components/SeparatorListItem";

import { client as http } from "@/http_client";
import moment from 'moment';

export default {
    components: {
        CardFooter, CardBody, CardHeader, CardList,
        SubheaderListItem, DataRow, SeparatorListItem
    },
    props: ['card', 'props', 'child'],
    data: function () {
        return {
            forecast: {},
            totalOwed: 0,
            totalPaid: 0,
            totalPlans: 0,
            monthStrings: [
                'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
            ],
            shortMonthStrings: [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ],
            moment: moment,
        };
    },
    methods: {
        loadReport() {
            this.$emit('loading', true);
            http.get('reports/admin/forecast', {}).then(response => {
                console.log(response.data);
                this.forecast = response.data.years;
                this.totalOwed = response.data.totals.totalOwed;
                this.totalPaid = response.data.totals.totalPaid;
                this.totalPlans = response.data.totals.totalPlans;
                this.activePlans = response.data.totals.activePlans;
                this.$emit('loading', false);
            });
        }
    },
    watch: {},
    mounted: function () {
        this.loadReport();
    }
};
</script>

<style lang="css" scoped>
.t-data-title {
    min-width: 40%;
}
</style>